function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { MenuItem, PopoverOnHover, TextButton, Typography } from 'seagull';
import { InitialsAvatar } from "./InitialsAvatar";
import { routes } from "../../../constants";
import { useHistory } from 'react-router-dom';
import { useStore, useStoreActions } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import styles from "./UserMenu.module.scss";
import { UserRole } from "../../../models";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LogoutIcon = () => /*#__PURE__*/_jsx("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M9.60034 23.1001H3.30037C2.66386 23.1001 2.05341 22.8403 1.60333 22.3777C1.15325 21.9151 0.900391 21.2877 0.900391 20.6335V3.36681C0.900391 2.71261 1.15325 2.08521 1.60333 1.62262C2.05341 1.16003 2.66386 0.900146 3.30037 0.900146H9.60034M17.1011 17.9999L23.101 12M23.101 12L17.1011 6M23.101 12L8.7002 12",
    stroke: "#696992",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
const Separator = () => /*#__PURE__*/_jsx("div", {
  className: styles.separator
});
const testPrefix = 'home-sidebar';
export const userMenuRoutes = [{
  id: routes.profile,
  text: 'Profile',
  url: routes.profile,
  shouldShow: true
}, {
  id: routes.anchorBilling,
  text: 'Anchor billing',
  url: routes.anchorBilling,
  shouldShow: _ref => {
    let {
      isVendor,
      role
    } = _ref;
    return isVendor && role !== UserRole.Member;
  }
}, {
  id: routes.importAgreements,
  text: 'Import agreements',
  url: routes.importAgreements,
  shouldShow: _ref2 => {
    let {
      isVendor
    } = _ref2;
    return isVendor;
  }
}];
export default function UserMenu(props) {
  const {
    userInfo
  } = props;
  const userInitials = userInfo && userInfo.userInitials();
  const history = useHistory();
  const {
    reset
  } = useStoreActions();
  const topbarLinks = useStore(selectors.filterAvailableRoutes(userMenuRoutes));
  return /*#__PURE__*/_jsx(PopoverOnHover, {
    placement: "bottom-end",
    openStrategy: "click",
    removePadding: true,
    showArrow: true,
    trigger: triggerProps => /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
      "data-testid": "home-sidebar-settings-btn"
    }, triggerProps), {}, {
      children: /*#__PURE__*/_jsx(InitialsAvatar, {
        userInitials: userInitials,
        "data-testid": "home-sidebar-avatar",
        isActive: triggerProps['data-popover-is-open'] === 'true'
      })
    })),
    content: _ref3 => {
      let {
        closePopover
      } = _ref3;
      const onClickOption = path => {
        history.push(path);
        closePopover();
      };
      return /*#__PURE__*/_jsxs("div", {
        className: styles.root,
        "data-testid": testPrefix + '-avatar-overflow-menu',
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.avatarContainer,
          children: [/*#__PURE__*/_jsx(InitialsAvatar, {
            userInitials: userInitials
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(Typography, {
              weight: "normal",
              children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.fullName()
            }), /*#__PURE__*/_jsx(Typography, {
              variant: "paragraph3",
              skin: "secondary",
              children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email()
            })]
          })]
        }), /*#__PURE__*/_jsx(Separator, {}), topbarLinks.map(_ref4 => {
          let {
            text,
            url,
            id
          } = _ref4;
          return /*#__PURE__*/_jsx(MenuItem, {
            skin: "secondary",
            "data-testid": "".concat(testPrefix, "-").concat(id),
            onClick: () => onClickOption(url),
            children: text
          }, id);
        }), /*#__PURE__*/_jsx(Separator, {}), /*#__PURE__*/_jsx(TextButton, {
          className: styles.logout,
          prefixIcon: /*#__PURE__*/_jsx(LogoutIcon, {}),
          underline: "none",
          size: "small",
          skin: "secondary",
          "data-testid": testPrefix + '-logout',
          onClick: () => {
            reset(true);
            history.push(routes.home);
          },
          children: "Log out"
        })]
      });
    }
  });
}